type ScrollAlign = "default" | "center";

const scrollToMessage = (
  messageId: number,
  highlith_message?: boolean,
  smooth_scroll?: boolean,
  align: ScrollAlign = "default",
) => {
  const element = document.getElementById(String(messageId));
  const parentContainer = document.querySelector(
    "#messageListDiv",
  ) as HTMLElement | null;

  if (!element || !parentContainer) return;

  const pinBar = document.querySelector(
    "[data-pin-bar]",
  ) as HTMLElement | null;
  const pinOffset = pinBar?.offsetHeight || 0;

  const runScroll = () => {
    const elRect = element.getBoundingClientRect();
    const parentRect = parentContainer.getBoundingClientRect();
    const visibleTop = parentRect.top + pinOffset;
    const visibleHeight = Math.max(
      parentContainer.clientHeight - pinOffset,
      1,
    );

    let targetTop: number;
    if (align === "center") {
      targetTop = visibleTop + visibleHeight / 2 - elRect.height / 2;
    } else {
      // Slightly below pin / header so the bubble isn't glued under the bar
      targetTop = visibleTop + 12;
    }

    const delta = elRect.top - targetTop;
    if (Math.abs(delta) < 1) return;

    parentContainer.scrollBy({
      top: delta,
      behavior: smooth_scroll ? "smooth" : "instant",
    });
  };

  // Layout may not be ready right after around-jump replace
  requestAnimationFrame(() => {
    runScroll();
    if (align === "center" || pinOffset) {
      // Second pass after images/layout settle
      window.setTimeout(runScroll, smooth_scroll ? 280 : 40);
    }
  });

  if (highlith_message) {
    element.classList.add("bg-selectedMessage");
    setTimeout(() => {
      element.classList.remove("bg-selectedMessage");
    }, 3500);
  }
};

export default scrollToMessage;
